$('.card-slider').each((i, el) => {
	const $slider = $(el);
	const { prevArrow, nextArrow } = Globals.sliders;
	const $controls = $slider.next('.js-slider-controls');
	const initialSlide = $slider.parents('.block-card-slider').data('initial-slide');

	let options = {
		mobileFirst: true,
		dots: true,
		prevArrow,
		nextArrow,
		appendArrows: $controls,
		appendDots: $controls,
		slidesToShow: 1,
		centerMode: true,
		centerPadding: '47px',
		infinite: true,
		responsive: [
			{
				breakpoint: 991,
				settings: 'unslick',
			},
		],
	};

	// Grid-2-across or grid-5-item (mobile slick only)
	if (
		$slider.hasClass('card-slider--grid-2-across') ||
		$slider.hasClass('card-slider--grid-5-item')
	) {
		options.slidesToShow = 1;
		options.slidesToScroll = 1;
		options.centerMode = true;
		options.centerPadding = '47px';
		options.infinite = true;
		options.responsive = [
			{
				breakpoint: 768,
				settings: 'unslick',
			},
		];
	}

	// Grid-3-across (mobile slick only)
	if (
		$slider.hasClass('card-slider--grid-3-across')

	) {
		options.slidesToShow = 1;
		options.slidesToScroll = 1;
		options.centerMode = true;
		options.centerPadding = '47px';
		options.infinite = true;
		options.responsive = [
			{
				breakpoint: 768,
				settings: 'unslick',
			},
		];
	}

	// Slide 2-across (1 slides on mobile, 2 slides on desktop)
	if ($slider.hasClass('card-slider--slide-2-across')) {
		options.infinite = true;
		options.centerMode = false;
		options.responsive = [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					centerMode: false,
				},
			},
		];
	}

	// Slide 2-across 1 peek (1 slides on mobile, 2.5 slides on desktop)
	if ($slider.hasClass('card-slider--slide-2-half-across')) {
		options.infinite = false;
		options.centerMode = false;
		options.slidesToShow = 1.15;
		options.responsive = [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2.5,
					slidesToScroll: 1,
					centerMode: false,
				},
			},
		];
	}

	// Reviews slider (3 slides on mobile and desktop)
	if ($slider.hasClass('card-slider--reviews')) {
		options.infinite = true;
		options.centerMode = false;
		options.responsive = [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: false,
				},
			},
		];
	}

	// Hide the slider controls if not enough items to slide
	$slider.on('init reInit setPosition', function (evt, slick) {
		if (!slick) return;

		var count = slick.slideCount;
		var sts   = slick.options.slidesToShow || 1;
		var isCenterSingle = slick.options.centerMode && sts === 1;

		var canSlide = isCenterSingle ? (count > 1) : (count > sts);

		if ($controls && $controls.length) {
		$controls.toggle(!!canSlide);
		}
	});

	$slider.slick(options);

	// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
	if ($slider.find('.slick-track').length === 0) {
		$slider.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
		$slider.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
	}
});
